module.exports = __webpack_public_path__ + "img/logo_athlon.37cdfa8a.webp";